import React, {
    useContext, useCallback
} from 'react';
import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { Link } from '@jutro/components';
import htmlParser from 'html-react-parser';
import { SgDocumentsUtil, SgWebchatUtil } from 'saga-modules';
import SgSptConstants from 'sg-spt-constants';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import messages from './SgSptRenewalPremium.messages';
import metadata from './SgSptRenewalPremium.metadata.json5';

function SgSptRenewalPremium(props) {
    const {
        renewalDetails
    } = props;
    const translator = useContext(TranslatorContext);
    const coverLevel = renewalDetails.coverLevel.toLowerCase();
    const isAggOriginated = coverLevel.includes(SgSptConstants.COVER_LEVELS.SELECT);
    const breakpoint = useContext(BreakpointTrackerContext);
    const isMobile = breakpoint === 'tablet' || breakpoint === 'phoneWide' || breakpoint === 'phone';

    const getRenewalDocWording = useCallback(() => {
        return (
            <span>
                {renewalDetails.renewalDocument && (
                    <p id="confirmRenewalWordingDocsAvailable">
                        {translator(messages.ConfirmRenewalLabelFirst)}
                        <Link
                            href="/"
                            id="downloadRenewalDocuments"
                            onClick={(event) => SgDocumentsUtil.downloadDocument(
                                event,
                                renewalDetails.renewalDocument.policyNumber,
                                renewalDetails.renewalDocument.sagaType
                            )}
                        >
                            {translator(messages.RenewalDocumentLabel)}
                        </Link>
                        {translator(messages.ConfirmRenewalLabelSecond)}
                    </p>
                )}
            </span>
        );
    }, [renewalDetails, translator]);

    const trackChat = useCallback((event) => {
        if (event) {
            event.preventDefault();
        }
        SgWebchatUtil.trackChat();
    }, []);

    const getWebChatWording = useCallback(() => {
        return (
            <span>
                <p id="webchatMessageRenewalPremium">
                    {isAggOriginated ? translator(messages.ComprehensiveCoverLabelAggs) : translator(messages.ComprehensiveCoverLabel)}
                    <Link
                        href="/"
                        id="webchatlinkRenewalPremium"
                        onClick={trackChat}
                        className="saga-intercom"
                    >
                        {translator(messages.ComprehensiveCoverLabelWebChat)}
                    </Link>
                    {translator(messages.ComprehensiveCoverLabelAlternatively, {
                        phoneNumber: isMobile
                            ? (
                                <a href={`tel:${SgSptConstants.PHONE_NUMBER_EXISTING_CUSTOMER.replaceAll(' ', '')}`}>
                                    {SgSptConstants.PHONE_NUMBER_EXISTING_CUSTOMER}
                                </a>
                            ) : <b>{SgSptConstants.PHONE_NUMBER_EXISTING_CUSTOMER}</b>
                    })}
                </p>
            </span>
        );
    }, [isAggOriginated, isMobile, trackChat, translator]);

    const overrideProps = {
        totalRenewalPriceAmount: {
            value: renewalDetails.premium.amount
        },
        totalCurrentPriceAmount: {
            value: renewalDetails.currentPremium.amount
        },
        comprehensiveCoverContainer: {
            content: getWebChatWording()
        },
        clickingAccept: {
            content: htmlParser(translator(messages.ClickingAcceptLabel))
        },
        renewalDocument: {
            content: getRenewalDocWording()
        },
        ConfirmRenewalLabelDocsUnavailableContainer: {
            visible: !renewalDetails.renewalDocument
        },
    };

    return renderContentFromMetadata(metadata.componentContent, overrideProps);
}

export default SgSptRenewalPremium;
